export const FIND_PSEUDONYM_REQUEST = 'FIND_PSEUDONYM_REQUEST';

export const findPseudonymRequest = ( id ) => ({
    type: FIND_PSEUDONYM_REQUEST,
    payload: { id }
});
